module.exports = __webpack_public_path__ + "img/tu04.f2019cb8.jpg";